import { Checkbox, InputSearch, Skeleton, Text } from '@mercai/clever'

import { useCatalogProductList } from '@/services'
import { useState } from 'react'
import { SelectCatalogProductProps } from './select-catalog-product.types'

import { CatalogProductProps } from '@/types'
import { useTranslation } from 'react-i18next'
import styles from './select-catalog-product.module.css'

export const SelectCatalogProduct = ({
  productsItem,
  onSelectProductItem,
  errors,
}: SelectCatalogProductProps) => {
  const { t } = useTranslation('screenSuppliers')

  const [search, setSearch] = useState('')

  const { data, isLoading } = useCatalogProductList({ search, limit: 10 })

  const onHandleSelect = (productItem: CatalogProductProps) => {
    onSelectProductItem(productItem)
  }

  const hasError = !!(errors?.catalogProductUuid || errors?.catalogProduct)

  const Loading = () => {
    return [1, 2, 3].map((val) => (
      <div key={val} className={styles.product}>
        <Skeleton height="1.5rem" width="100%" />
        <Skeleton height="1.2rem" width="40%" />
        <Skeleton height="1.2rem" width="45%" />
        <Skeleton height="1.2rem" width="25%" />
      </div>
    ))
  }

  const ProductButton = ({ product }: { product: CatalogProductProps }) => {
    const { attributes, category, reference, uuid } = product

    const isActive = productsItem?.some(
      (productItem) => productItem.uuid === uuid,
    )

    return (
      <button
        key={uuid}
        className={`${styles.product} ${isActive ? styles.active : ''} ${hasError ? styles.error : ''}`}
        onClick={() => onHandleSelect(product)}
      >
        <div>
          <Checkbox
            value={!!isActive || false}
            onChange={() => onHandleSelect(product)}
          />
        </div>
        <div>
          <div>
            <Text variant="text-base">
              <strong>{attributes?.title}</strong>
            </Text>
          </div>
          <div className={styles.row}>
            <Text>
              <strong>{t('newSupplierProductsFormCategoryLabel')}</strong>{' '}
              {category?.name}
            </Text>
          </div>

          {reference && (
            <div className={styles.row}>
              <Text>
                <strong>{t('newSupplierProductsFormReferenceLabel')}</strong>{' '}
                {reference}
              </Text>
            </div>
          )}

          {attributes?.fluidity && (
            <div className={styles.row}>
              <Text>
                <strong>{t('newSupplierProductsFormFluidityLabel')}</strong>{' '}
                {attributes?.fluidity} g/10m
              </Text>
            </div>
          )}

          {attributes?.density && (
            <div className={styles.row}>
              <Text>
                <strong>{t('newSupplierProductsFormDensityLabel')}</strong>{' '}
                {attributes?.density} g/cm³
              </Text>
            </div>
          )}
        </div>
      </button>
    )
  }

  return (
    <div className={styles.core}>
      <InputSearch
        value={search}
        onChange={setSearch}
        translations={{
          inputPlaceholder: t('newSupplierProductsFormInputSearchPlaceholder'),
        }}
      />

      {isLoading && <Loading />}

      {!isLoading && (
        <div className={styles.products}>
          {productsItem?.map((product) => {
            const hasInData = data?.data?.results?.some(
              (productItem) => productItem.uuid === product.uuid,
            )
            if (hasInData) return null
            return <ProductButton product={product} key={product?.uuid} />
          })}
          {data?.data?.results?.map((product) => (
            <ProductButton product={product} key={product?.uuid} />
          ))}
        </div>
      )}
    </div>
  )
}
